import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instance23prvj6kllmmf as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.o3v_1 = 8192;
        this.p3v_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.r3v_1 = 0;
  _this__u8e3s4.s3v_1 = 0;
  _this__u8e3s4.t3v_1 = false;
  _this__u8e3s4.u3v_1 = false;
  _this__u8e3s4.v3v_1 = null;
  _this__u8e3s4.w3v_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static x3v() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.q3v_1 = new Int8Array(8192);
        $this.u3v_1 = true;
        $this.t3v_1 = false;
        return $this;
      }
      static y3v(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.q3v_1 = data;
        $this.r3v_1 = pos;
        $this.s3v_1 = limit;
        $this.t3v_1 = shared;
        $this.u3v_1 = owner;
        return $this;
      }
      z3v() {
        this.t3v_1 = true;
        return Segment().y3v(this.q3v_1, this.r3v_1, this.s3v_1, true, false);
      }
      a3w() {
        var result = !(this.v3v_1 === this) ? this.v3v_1 : null;
        ensureNotNull(this.w3v_1).v3v_1 = this.v3v_1;
        ensureNotNull(this.v3v_1).w3v_1 = this.w3v_1;
        this.v3v_1 = null;
        this.w3v_1 = null;
        return result;
      }
      b3w(segment) {
        segment.w3v_1 = this;
        segment.v3v_1 = this.v3v_1;
        ensureNotNull(this.v3v_1).w3v_1 = segment;
        this.v3v_1 = segment;
        return segment;
      }
      c3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.s3v_1 - this.r3v_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().n2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.z3v();
        } else {
          prefix = SegmentPool_instance.f3w();
          var tmp0 = this.q3v_1;
          var tmp2 = prefix.q3v_1;
          var tmp5 = this.r3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.r3v_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.s3v_1 = prefix.r3v_1 + byteCount | 0;
        this.r3v_1 = this.r3v_1 + byteCount | 0;
        ensureNotNull(this.w3v_1).b3w(prefix);
        return prefix;
      }
      g3w() {
        // Inline function 'kotlin.check' call
        if (!!(this.w3v_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.w3v_1).u3v_1)
          return Unit_instance;
        var byteCount = this.s3v_1 - this.r3v_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.w3v_1).s3v_1 | 0) + (ensureNotNull(this.w3v_1).t3v_1 ? 0 : ensureNotNull(this.w3v_1).r3v_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.h3w(ensureNotNull(this.w3v_1), byteCount);
        this.a3w();
        SegmentPool_instance.i3w(this);
      }
      h3w(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.u3v_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.s3v_1 + byteCount | 0) > 8192) {
          if (sink.t3v_1)
            throw IllegalArgumentException().od();
          if (((sink.s3v_1 + byteCount | 0) - sink.r3v_1 | 0) > 8192)
            throw IllegalArgumentException().od();
          var tmp0 = sink.q3v_1;
          var tmp2 = sink.q3v_1;
          var tmp5 = sink.r3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.s3v_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.s3v_1 = sink.s3v_1 - sink.r3v_1 | 0;
          sink.r3v_1 = 0;
        }
        var tmp0_0 = this.q3v_1;
        var tmp2_0 = sink.q3v_1;
        var tmp4 = sink.s3v_1;
        var tmp6 = this.r3v_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.r3v_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.s3v_1 = sink.s3v_1 + byteCount | 0;
        this.r3v_1 = this.r3v_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.x3v);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
